<template>
  <div>
    <LIcon>
      <div class="marker">
        <v-icon v-if="itemLocal.type === 'M'"  class="action-icon">
          mdi-map-marker
        </v-icon>
        <v-icon v-if="itemLocal.type === 'A'" class="action-icon">
          mdi-home-import-outline
        </v-icon>
        <v-icon v-if="itemLocal.type === 'G'" class="action-icon" style="padding-left: 3px;">
          mdi-gate-alert
        </v-icon>
        <v-icon v-if="itemLocal.type === 'B'" class="action-icon" style="padding-left: 3px; padding-bottom: 3px">
          mdi-boom-gate
        </v-icon>
      </div>
    </LIcon>
    <LTooltip>
      <template v-if="itemLocal.type === 'B'">
        {{ itemLocal.address }}, {{ getDirectionType(itemLocal.direction) }}
      </template>
      <template v-else>
        {{ itemLocal.address }}
      </template>
    </LTooltip>

    <LPopup v-if="roleName !== 'checkpoint-admin'">
      <div ref="anchor" class="base-popup">
        <div style="cursor: pointer">
          <h4>Id: {{ formattedId }}</h4>
          <h4 v-if="itemLocal.diapason">Диапазон квартир: {{ itemLocal.diapason }}</h4>
          <h4>
            Статус:
            {{ itemLocal.sip_status_text }}
            <v-icon x-small :color="itemLocal.sip_status_color">mdi-checkbox-blank-circle</v-icon>
          </h4>
          <h4 v-if="itemLocal.type === 'B'">
            Направления движения:
            {{ getDirectionType(itemLocal.direction) }}
          </h4>
          <router-link v-if="itemLocal.type !== 'B'" class="routerLink" :to="`/doorphones/${itemLocal.id}`">
            <h4>Адрес: {{ itemLocal.address }} <v-icon class="ml-2">mdi-arrow-right-bold-box</v-icon></h4>
          </router-link>
          <router-link v-else class="routerLink" :to="`/barrier/${itemLocal.id}`">
            <h4>Адрес: {{ itemLocal.address }}, {{ displayType(itemLocal.passage_type) }} <v-icon class="ml-2">mdi-arrow-right-bold-box</v-icon></h4>
          </router-link>
        </div>
        <v-img
          :src="itemLocal.snapshot"
          max-width="300"
          contain
          class="image-doorphone mt-2"
          alt="Изображение отсутствует"
        ></v-img>
        <slot :is-active="isActive" name="default"/>
      </div>
    </LPopup>
  </div>
</template>

<script>
import { LIcon, LTooltip, LPopup } from 'vue2-leaflet';
import { mapGetters } from 'vuex';
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    LTooltip,
    LPopup,
    LIcon,
  },
  data () {
    return {
      isActive: false,
      itemLocal: this.item,
    };
  },
  watch: {
    item: {
      handler (newValue) {
        this.itemLocal = newValue;
      },
      deep: true,
    },
  },
  methods: {
    displayType (item) {
      switch (item) {
        case 'B': return '(Шлагбаум)';
        case 'G': return '(Ворота)';
        default: return '';
      }
    },
    getDirectionType (item) {
      switch (item) {
        case 1: return 'Въезд/Выезд';
        case 2: return 'Только въезд';
        case 3: return 'Только выезд';
        default: return '';
      }
    },
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
    }),
    formattedId () {
      return this.itemLocal.type === 'B' ? `_${this.itemLocal.id}` : this.itemLocal.id;
    },
  },
};
</script>
<style scoped>
.no-pointer-events {
  pointer-events: none;
}
</style>
